var map = {
	"./pay-cn-btn.png": "EUv0",
	"./pay-de-btn.png": "jwg4",
	"./pay-en-btn.png": "YABr",
	"./pay-es-btn.png": "rDxA",
	"./pay-fr-btn.png": "Aa2j",
	"./pay-pt-btn.png": "DG/e"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qdJp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/pay ^\.\/pay\-.*\-btn\.png$
// module id = qdJp
// module chunks = 1